module.exports = __webpack_public_path__ + "img/3-1.885aeb56.webp";